import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Modal, Button, Select, Steps, Spin } from 'antd'
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons'

import { integrateCronofy } from '../../reducers/integrations/resources'
import mixpanel from '../../utils/mixpanel'

class CronofyCalendarDialog extends Component {
  componentWillMount() {
    this.setState({
      calendarId: '',
      stepIndex: 0,
      isError: false,
    })
  }

  closeDialog = async () => {
    const { setIntegrationState, loadApps } = this.props
    setIntegrationState({ showCronofyDialog: false, calendars: [] })
    this.setState({ calendarId: '', stepIndex: 0 })
    await loadApps()
  }

  integrateCronofy = async () => {
    const { calendarId } = this.state
    const { setIntegrationState, cronofyData } = this.props

    mixpanel.track(
      'integrations:integrate cronofy',
      { data: { appId: cronofyData.appId } }
    );

    if (!calendarId) {
      return setIntegrationState({
        showSnackBar: true,
        snackBarMessage: 'Please select a calendar before submitting',
      })
    }

    this.setState({ stepIndex: 1 })

    try {
      const { userId, appId, tokenData } = cronofyData
      const data = {
        userId,
        appId,
        calendarId,
        tokenData,
      }

      let integrationResult = await integrateCronofy(data)

      this.setState({ stepIndex: 2, isError: integrationResult.data.isError })
    } catch (error) {
      this.setState({ stepIndex: 2, isError: true })

      setIntegrationState({
        showSnackBar: true,
        snackBarMessage: error.message,
      })
    }
  }

  getStepContent(stepIndex) {
    const calendarOptions = this.props.calendars
      .filter((calendar) => !calendar.calendar_readonly)
      .map((calendar) => ({
        value: calendar.calendar_id,
        label: calendar.calendar_name,
      }))

    switch (stepIndex) {
      case 0:
        return (
          <div>
            <Row style={{ marginTop: '30px' }}>
              <Col xs={24} className="text-center">
                Choose the calendar to integrate to
              </Col>
            </Row>
            <Row style={{ marginTop: '12px' }}>
              <Col xs={24} className="text-center">
                <Select
                  style={{ minWidth: 240, textAlign: 'left' }}
                  placeholder="Select a calendar"
                  value={this.state.calendarId || undefined}
                  options={calendarOptions}
                  onChange={(value) => this.setState({ calendarId: value })}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: '20px' }}>
              <Col xs={24} style={{ textAlign: 'right' }}>
                <Button
                  type="primary"
                  disabled={!this.state.calendarId}
                  onClick={() => this.integrateCronofy()}
                >
                  Next
                </Button>
              </Col>
            </Row>
          </div>
        )
      case 1:
        return (
          <div>
            <Row style={{ marginTop: '30px' }}>
              <Col xs={24} className="text-center">
                <Spin size="large" />
              </Col>
            </Row>
            <Row style={{ marginTop: '30px', marginBottom: '45px' }}>
              <Col xs={24} className="text-center">
                Please wait while we validate the connection
              </Col>
            </Row>
          </div>
        )
      case 2:
        return (
          <div>
            {!this.state.isError ? (
              <div>
                <Row style={{ marginTop: '30px' }}>
                  <Col xs={24} className="text-center">
                    <CheckCircleFilled style={{ fontSize: '72px', color: '#39B549' }} />
                  </Col>
                </Row>
                <Row style={{ marginTop: '30px', marginBottom: '45px' }}>
                  <Col xs={24} className="text-center">
                    <span style={{ display: 'block', fontWeight: 'bold' }}>
                      {'Hooray! Your calendar is now connected to GoHire.'}
                    </span>
                    <span>
                      {
                        'You can now start texting candidates to self-select times for an interview or pre-screening call.'
                      }
                    </span>
                  </Col>
                </Row>
              </div>
            ) : (
              <div>
                <Row style={{ marginTop: '30px' }}>
                  <Col xs={24} className="text-center">
                    <CloseCircleFilled style={{ fontSize: '72px', color: '#EB3C00' }} />
                  </Col>
                </Row>
                <Row style={{ marginTop: '30px', marginBottom: '45px' }}>
                  <Col xs={24} className="text-center">
                    <span style={{ display: 'block', fontWeight: 'bold' }}>
                      {'There seems to be a connection issue with your calendar.'}
                    </span>
                    <span>
                      {
                        'We’ve sent a notification to the GoHire support team to look into it. You will be copied on the Support Request email.'
                      }
                    </span>
                  </Col>
                </Row>
              </div>
            )}

            <Row style={{ marginTop: '20px' }}>
              <Col xs={24} style={{ textAlign: 'right' }}>
                <Button type="primary" onClick={() => this.closeDialog()}>
                  Close
                </Button>
              </Col>
            </Row>
          </div>
        )
      default:
        return null
    }
  }

  render() {
    return (
      <Modal
        open={this.props.openDialog}
        footer={null}
        closable={false}
        maskClosable={false}
      >
        <Steps
          size="small"
          current={this.state.stepIndex}
          items={[
            { title: 'Select Calendar' },
            { title: 'Integration' },
            { title: 'Done' },
          ]}
        />
        {this.getStepContent(this.state.stepIndex)}
      </Modal>
    )
  }
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = () => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CronofyCalendarDialog)
